import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const CategoryCarousal = ({ carousalCategory, handleCategoryFilter }) => {
    const [selectedCategory, setSelectedCategory] = useState([]);

    const handleCategoryFilterChange = (category) => {
        if (handleCategoryFilter) {
            setSelectedCategory((prevState) => {
                handleCategoryFilter(category,prevState);
                if (prevState.includes(category.id)) {
                    return prevState.filter(id => id !== category.id);
                } else {
                    return [...prevState, category.id]
                }
            });
        }
    };
    console.log(selectedCategory, "selectedCategory")
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="package_types">
                    <OwlCarousel
                        className="owl-theme"
                        margin={10}
                        dots={false}
                        responsive={{
                            0: { items: 1 },
                            600: { items: 2 },
                            1000: { items: 5 },
                        }}
                        key={`${carousalCategory.length}_${selectedCategory.length}`}
                    >
                        {carousalCategory.map((pkg) => (
                            <div
                                className={`item ${selectedCategory.includes(pkg.id)
                                    ? "selected"
                                    : ""}`}
                                key={pkg.id}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="pack_category position-relative" onClick={() =>
                                    handleCategoryFilterChange(pkg)
                                }>
                                    <img src={pkg.imageUrl} alt={pkg.name} />
                                    <div className="pack_category_title">{pkg.name}</div>
                                </div>
                            </div>
                        ))}
                    </OwlCarousel>
                </div>
            </div>
        </div>
    );
};

export default CategoryCarousal;
